import InfoCard from './InfoCard';

interface RenderCardProps {
  title: string;
  value?: React.ReactNode;
  action?: React.ReactNode;
  tooltip?: string;
  dataTestId?: string;
  showCopyIcon?: boolean;
  tooltipIconSize?: number;
}

const RenderCard: React.FC<RenderCardProps> = (props) => (
  <InfoCard {...props} />
);

export default RenderCard;
